import { useState } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelBReportFilter } from "../../types/levelb-reports";

export function useExportLevelBParticipantQuestionDetails() {
  const { t } = useTranslation();
  const axios = useAxios();
  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async (filter: LevelBReportFilter) => {
    if (!filter.examTermId) {
      message.warning(t("levelBReports.participantPoints.selectTerm"));
      return;
    }

    setIsExporting(true);
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
        examTermId: filter.examTermId,
      });

      const response = await axios.get(`/api/levelbreports/participant-question-details/export?${params}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const date = new Date(filter.startDate).toISOString().split("T")[0];
      link.setAttribute("download", `participant-question-details-${date}.xlsx`);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(t("levelBReports.questionDetails.exportSuccess"));
    } catch (error) {
      console.error("Export failed:", error);
      message.error(t("levelBReports.questionDetails.exportError"));
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    isExporting,
  };
}
